import React,{Component} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';


import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
//import ContentDelete from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ViewIcon from '@mui/icons-material/ViewCompact';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { lighten } from '@mui/system/colorManipulator';
import { Box, type Theme } from '@mui/material';

const s:any = {
  root: {
    pr: 1,
  },
  // highlight:
  //   theme.palette.mode === 'light'
  //     ? {
  //         color: 'secondary.main',
  //         backgroundColor: lighten(theme.palette.secondary.light, 0.85),
  //       }
  //     : {
  //         color: 'text.primary',
  //         backgroundColor: 'secondary.dark',
  //       },
  highlight:(theme: Theme) => ({
          color: 'secondary.main',
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        })
      ,
  spacer: {
    flex: '1 1 100%',
  },
  actionlist: {
    display: 'flex'
  },
  actions: {
    color: 'text.secondary',
  },
  title: {
    flex: '0 0 auto',
  },
};

//TODO: get title from props

class GridMSMToolbar extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      mode:0
    };
  }
  
  render() {
    const { title, numSelected, selectedRecord, handleSelect, handleFilter, classes } = this.props;
    
    return (
      <Toolbar
        className={classNames(classes.root, {
          [classes.highlight]: numSelected > 0,
        })}
      >
        {/* <Box sx={{...s.title}}>
          {numSelected > 0 ? (
            <Typography color="inherit" variant="subheading">
              {numSelected} selected
            </Typography>
          ) : (
            <Typography variant="title" id="tableTitle">
              {title}
            </Typography>
          )}
        </Box> */}
        <Box sx={{...s.title}}>
          <Typography variant="h1" id="tableTitle">
            {title}
          </Typography>
        </Box>
        <Box sx={{...s.spacer}} />
        <Box sx={{...s.title}}>
        {numSelected > 0 && (
          <Typography color="inherit" variant="subtitle1">
            {numSelected} selected
          </Typography>
        )}
        </Box>
        {(numSelected > 0) ? (
          (numSelected > 1)? (
            <Box sx={{...s.actions}}>
              <Tooltip title="Delete">
                <IconButton aria-label="Delete" onClick={handleSelect({item:selectedRecord,action:'delete'})}>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </Box>
          ):(
          <Box component='span' sx={{...s.actionlist}}>
            <Box sx={{...s.actions}}>
              <Tooltip title="Edit">
                <IconButton aria-label="Edit" onClick={handleSelect({item:selectedRecord,action:'edit'})}>
                  <EditIcon />
                </IconButton>
              </Tooltip>
              </Box>
              <Box sx={{...s.actions}}>
              <Tooltip title="View">
                <IconButton aria-label="View" onClick={handleSelect({item:selectedRecord,action:'view'})}>
                  <ViewIcon />
                </IconButton>
              </Tooltip>
              </Box>
              <Box sx={{...s.actions}}>
              <Tooltip title="Delete">
                <IconButton aria-label="Delete" onClick={handleSelect({item:selectedRecord,action:'delete'})}>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
          ) 
          ): (
          <Box sx={{...s.actions}}>
            <Tooltip title="Filter list">
              <IconButton aria-label="Filter list" onClick={handleFilter}>
                <FilterListIcon />
              </IconButton>
            </Tooltip>
          </Box>
          )}
        
      </Toolbar>
    );
  }
}

GridMSMToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

export default GridMSMToolbar;
